export const PENDING = 1;
export const APPROVED = 2;
export const REJECTED = 3;
